import React from 'react';
import IconExit from '../../../../../components/icon/IconExit';
import './modal.scss';

const Modal = ({ modalData, handleCloseModal }) => {
  let data = modalData?.[0] ?? null;
  console.log(modalData);

  const userStatus = {
    consideration: 'РАССМАТРИВАЕТСЯ',
    approved: 'ОДОБРЕНО',
    checking: 'НА ПРОВЕРКУ',
    considered: 'РАССМОТРЕНО',
    denied: 'ОТКАЗАНО',
    processed: 'ОБРАБОТАН',
    received: 'ПРИНЯТО',
  };

  return (
    <div className="dash-modal-background">
      <div className="dash-modal-container">
        <div className="dash-modal-header">
          <div>История статусов</div>
          <div onClick={handleCloseModal}>
            <IconExit />
          </div>
        </div>
        <div>
          <div className="information-top-header">
            <span>{data?.full_name} </span>
          </div>
          <div className="row">
            <div style={{ overflow: 'scroll' }} className="col-12">
              <table className="table">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Номер транша</th>
                    <th>Новая дата оплаты</th>
                    <th>Старая дата оплаты</th>
                    <th>Статус</th>
                    <th>Дата создание заявки</th>
                    <th>Дата изменение заявки</th>
                  </tr>
                </thead>
                <tbody>
                  {data === null ? (
                    <h5>Нет информации</h5>
                  ) : (
                    <tr>
                      <td>{data.id}</td>
                      <td>{data.number}</td>
                      <td>{data.new_date}</td>
                      <td>{data.old_date}</td>
                      <td>
                        <span className={`status-${data.status}`}>
                          {userStatus[data.status]}
                        </span>
                      </td>
                      <td>{data.create_date}</td>
                      <td>{data.last_update}</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
